module.exports = __webpack_public_path__ + "static/media/right_arrow.35614e35.svg";